import React from "react";
import { Typography } from "@material-ui/core";

const CustomCardHeading = props => (
  <div>
    <Typography variant="subheading" className="centerCell">
      {props.subheading}
    </Typography>
    <Typography variant="caption" className="centerCell">
      {props.caption}
    </Typography>
    <div
      style={{
        borderBottom: "1px solid #cccccc69",
        margin: "5px auto",
        width: "25%"
      }}
    />

    <Typography
      variant="headline"
      className="centerCell"
      style={{
        marginBottom: "35px"
      }}
    >
      {props.headline}
    </Typography>
  </div>
);

export default CustomCardHeading;



// WEBPACK FOOTER //
// ./src/views/Fna/components/CustomCardHeading.jsx